import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from '../actions/user';
import Header from "../components/Header";
// import LoginForm from "../components/LoginForm";
import {Redirect} from 'react-router-dom';

class LoginPage extends Component {
    constructor(props) {
      super(props);

      // reset login status
      this.props.dispatch(userActions.logout());

      this.state = {
          username: '',
          password: '',
          error: '',
          submitted: false,
          redirect: false
      }

      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
      const { name, value } = e.target;
      this.setState({ [name]: value })
  }

  handleSubmit(e) {
      e.preventDefault();

      this.setState({ submitted: true });
      const { username, password } = this.state;
      const { dispatch } = this.props;
      if( username && password ) {
        var data  = {
          "username": username,
          "password": password
        }
        dispatch(userActions.login(data))
          // this.props.loginUser(this.state)
          // console.log("login status: " + this.state.loginStatus)
          // console.log("loggedin:" + JSON.stringify(this.props.loggedIn))
      }
  }

  render() {
    const { loggedIn } = this.props.loggedIn;
    const { username, password } = this.state;
    if(loggedIn) {
        return <Redirect to="/moderation" />;
    }
    return (
      <div className="row">
        <Header />
          <div className="col l4 m4 s12 push-l5 push-m5 valign-wrapper" id="navigator_wrap">
              <form className="left-align" onClick={ this.handleSubmit }>
                  <span className="red-text">{ this.props.loggedInError }</span>
                  <input type="text" placeholder="username" name="username" onChange={this.handleChange} />
                  <input type="password" placeholder="password" name="password" onChange={this.handleChange}/>
                  <button value="submit" className="col s12 btn" disabled={this.loggingIn}>Login</button>
              </form>
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggedIn } = state.user;
  return {
    loggedIn: state.user,
    loggedInError : state.user.loggedInError
    
  }
}
export default connect(mapStateToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js